import * as React from 'react'
const SvgIcoCataMidis = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 200 200'
    {...props}
  >
    <style>
      {
        '.ICO_CataMidis_N_svg__st0{display:none}.ICO_CataMidis_N_svg__st1{display:inline}.ICO_CataMidis_N_svg__st2{fill:#7984ba}.ICO_CataMidis_N_svg__st3,.ICO_CataMidis_N_svg__st4{fill-rule:evenodd;clip-rule:evenodd}.ICO_CataMidis_N_svg__st4{fill:#7984ba}'
      }
    </style>
    <g id='ICO_CataMidis_N_svg__Calque_15'>
      <path d='m116.71 105.54 17.03-16.18-10.62-11.18zM110.89 88.29l.33 1.01 4.24 13.24 5.2-22.21.4-1.69.37-1.6-.06-.02-15.09-3.53-.05.23 4.34 13.56zM104.82 75.57l-.57-1.77-.16-.5-14.81 4.75.54 1.7 10.56 10.56.8.8.79.79 1.82 1.82.68.68.67.67 8.67 8.67.02-.05-4.15-12.93-.32-1.01-.32-1.01-3.66-11.4zM87.56 78.84l-.03.03-10.97 10.97 19.4 19.4.79.79.79.79.34.34.24.24 1.01 1.01.22.22.8.8.68.68.76.76.71.71.71.71 1.07 1.07 3.41-3.41.08-.08.15-.15.75-.75.38-.38.52-.52.38-.38.24-.24 2.02-2.02.1-.1 1.45-1.45.89-.89.56-.56.08-.08-.04-.04-.36-.36-.41-.41-.76-.76-9.04-9.04-.67-.67-.67-.67-1.39-1.39-.79-.79-.79-.79-9.68-9.68-1.47-1.47zm17.73 26.06c1.57 0 2.84 1.27 2.84 2.84s-1.27 2.84-2.84 2.84-2.84-1.27-2.84-2.84 1.27-2.84 2.84-2.84' />
    </g>
  </svg>
)
export default SvgIcoCataMidis

